import { NetworkService } from './network-service';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class AssignedCompanyService {

    static getAssignedCompanies = (callback, errCallback, queryParams) => {
        NetworkService.get(`${API_BASE_URL}/assignedCompany`, callback, errCallback, queryParams);
    };

    static getAssignedCompany = (assignedCompanyId, callback, errCallback, queryParams) => {
        NetworkService.get(`${API_BASE_URL}/assignedCompany/${assignedCompanyId}`, callback, errCallback, queryParams);
    };

    static getAssignedCompanyByCompanyId = (companyId, callback, errCallback, queryParams) => {
        NetworkService.get(`${API_BASE_URL}/assignedCompany/company/${companyId}`, callback, errCallback, queryParams);
    };

    static assignCompany = (companyId, callback, errCallback, queryParams) => {
        NetworkService.post(`${API_BASE_URL}/assignedCompany/company/${companyId}`, {}, callback, errCallback, queryParams);
    };
}
